import { buildComponent } from '#components'
import { decode } from '#libs'
import { z } from 'zod'
import HomepageFeaturedCollectionVue from './HomepageFeaturedCollection.vue'

import './homepage-featured-collection.css'

const HomepageFeaturedCollectionPropsSchema = z.object({
  title: z.string(),
  products: z.array(
    z.object({
      id: z.number(),
      title: z.string(),
      image: z.string(),
      imageHtml: z.string().transform((value) => decode(value)),
      price: z.string(),
      url: z.string(),
      available: z.boolean().default(false),
      variantId: z.number().nullable(),
      excerpt: z.string(),
      color: z
        .object({
          name: z.string(),
          code: z.string(),
          swatchImage: z.string().nullable()
        })
        .nullable()
    })
  ),
  section: z.object({
    id: z.string()
  })
})

export type HomepageFeaturedCollectionProps = z.infer<typeof HomepageFeaturedCollectionPropsSchema>

const HomepageFeaturedCollection = buildComponent({
  name: 'homepage-featured-collection',
  propsSchema: HomepageFeaturedCollectionPropsSchema,
  vueComponent: HomepageFeaturedCollectionVue
})

// Don't forget to declare the element tag name
// this is helpful for TypeScript to recognize the element
declare global {
  interface HTMLElementTagNameMap {
    'homepage-featured-collection': typeof HomepageFeaturedCollection
  }
}
